import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsPanel } from "../components/settings/AccountSettings";
import { redirectUnlessOfferedOnClient } from "../components/settings/settingsClientBridges";

export const Route = createFileRoute("/settings/account")({
  // Keyed off the Connect bridge, not `isElectron`: where there is no bridge there is nothing to
  // sign into. Configured browser clients use the same account surface as Desktop.
  beforeLoad: () => redirectUnlessOfferedOnClient("/settings/account"),
  component: AccountSettingsPanel,
});
